<ng-container [ngSwitch]="type">
    <ng-container *ngSwitchCase="OverlayType.STRING">
        <span>{{content}}</span>
    </ng-container>
    <ng-container *ngSwitchCase="OverlayType.TEMPLATE">
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </ng-container>
</ng-container>